import { Container } from "@chakra-ui/react"
import HeaderLayout from "@components/layout/HeaderLayout"
import { readItem } from "@directus/sdk"
import directusClient from "@utils/directus"
import { GetStaticProps, InferGetStaticPropsType, NextPage } from "next"
import dynamic from "next/dynamic"
import { MDXRemote } from "next-mdx-remote"
import { serialize } from "next-mdx-remote/serialize"
import { NextSeo } from "next-seo"

const DynamicFooter = dynamic(() => import("@components/layout/Footer"), {
  ssr: false,
})

const Privacy: NextPage = ({
  page_data,
  content,
  locales,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <>
      <NextSeo
        title={page_data.meta_title}
        description={page_data.meta_description}
        canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/${page_data.slug}`}
        languageAlternates={locales.map((lang: string) => ({
          hrefLang: lang,
          href: `${process.env.NEXT_PUBLIC_SITE_URL}/${lang}/${page_data.slug}`,
        }))}
        additionalMetaTags={[
          {
            name: "keywords",
            content: page_data.meta_keywords,
          },
        ]}
      />
      <HeaderLayout />
      <Container
        maxW={"container.xl"}
        px={{ base: 10, xl: 0 }}
        color={"brand.black"}
      >
        <MDXRemote
          {...content}
          lazy
        />
      </Container>
      <DynamicFooter />
    </>
  )
}

export default Privacy

export const getStaticProps: GetStaticProps = async ({ locale, locales }) => {
  // Page meta data
  const page_data = await directusClient
    .request(
      readItem("emenu_pages", 7, {
        fields: ["slug", { translations: ["*"] }],
      })
    )
    .then((res) => {
      const translations = res?.translations?.find(
        (t) => t.languages_id === locale
      )
      return {
        slug: res?.slug,
        meta_title: translations?.meta_title,
        meta_description: translations?.meta_description,
        meta_keywords: translations?.meta_keywords,
        title: translations?.title,
        content: translations?.content,
      }
    })
  const content = await serialize(page_data?.content ? page_data.content : "")

  return {
    props: {
      page_data,
      content,
      locales,
      messages: {
        ...require(`@messages/shared/${locale}.json`),
      },
    },
  }
}
